<main class="not-found">
  <div class="not-found-card">
    <div class="not-found-code" aria-hidden="true">404</div>
    <mat-icon class="not-found-icon" aria-hidden="true">travel_explore</mat-icon>
    <h1>{{ 'Page not found' | translate }}</h1>
    <p>{{ "The page you're looking for doesn't exist or has been moved." | translate }}</p>
    <div class="not-found-actions">
      <button type="button" class="btn-secondary" (click)="goBack()">
        {{ 'Go back' | translate }}
      </button>
      <button type="button" class="btn-primary" (click)="goHome()">
        {{ 'Go to Home' | translate }}
      </button>
    </div>
  </div>
</main>
